(() => {
  const header = document.querySelector('[data-a26-header]');
  if (header) {
    const toggle = header.querySelector('[data-a26-menu-toggle]');
    const menu = header.querySelector('[data-a26-menu]');
    toggle?.addEventListener('click', () => {
      const open = header.classList.toggle('menu-is-open');
      toggle.setAttribute('aria-expanded', String(open));
      menu?.setAttribute('data-open', String(open));
    });
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -60px', threshold: 0.08 })
    : null;

  document.querySelectorAll('[data-a26-reveal]').forEach((element) => {
    if (observer) observer.observe(element);
    else element.classList.add('is-visible');
  });

  const giftPreview = document.querySelector('[data-a26-gift-preview]');
  if (giftPreview) {
    const amount = giftPreview.querySelector('[data-a26-gift-amount]');
    const mockup = giftPreview.querySelector('[data-a26-gift-image]');
    const productPrice = document.querySelector('.product__price .price__main__value');
    const updateAmount = (rawValue) => {
      const numericValue = Number(String(rawValue || '').replace(/[^0-9.]/g, ''));
      if (!amount || !Number.isFinite(numericValue) || numericValue <= 0) return;
      const valueKey = String(Math.round(numericValue));
      const formattedValue = numericValue.toLocaleString('he-IL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const source = mockup?.getAttribute(`data-gift-${valueKey}`);
      if (mockup && source) {
        mockup.src = source;
        mockup.alt = `תמונת שובר גיפט קארד Anime Shop בסך ${valueKey} ₪`;
      }
      amount.textContent = `${valueKey} ₪`;
      if (productPrice) productPrice.textContent = `${formattedValue} ₪`;
      document.querySelectorAll('.variants-label__value').forEach((label) => {
        label.textContent = valueKey;
      });
      document.querySelectorAll('select[name="id-sticky"]').forEach((select) => {
        const matchingOption = Array.from(select.options).find((option) => option.textContent.trim().startsWith(valueKey));
        if (matchingOption) select.value = matchingOption.value;
      });
      giftPreview.setAttribute('aria-label', `גיפט קארד - ${formattedValue} ₪`);
    };

    document.addEventListener('change', (event) => {
      const control = event.target;
      if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) return;
      if (!control.matches('variant-radios input[type="radio"], variant-selects select')) return;
      updateAmount(control.value);
    });

    const selectedControl = document.querySelector(
      'variant-radios input[type="radio"]:checked, variant-selects select'
    );
    if (selectedControl) updateAmount(selectedControl.value);
  }

  const seriesCarousel = document.querySelector('[data-a26-series-carousel]');
  if (seriesCarousel) {
    const track = seriesCarousel.querySelector('[data-a26-series-track]');
    const previous = seriesCarousel.querySelector('[data-a26-series-prev]');
    const next = seriesCarousel.querySelector('[data-a26-series-next]');
    const getStep = () => {
      const card = track?.querySelector('.a26-series-card');
      return card ? card.getBoundingClientRect().width + 16 : 320;
    };

    previous?.addEventListener('click', () => track?.scrollBy({ left: getStep() * 2, behavior: 'smooth' }));
    next?.addEventListener('click', () => track?.scrollBy({ left: getStep() * -2, behavior: 'smooth' }));

    if (track) {
      let dragging = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 6) moved = true;
        track.scrollLeft = startScroll - distance;
      });

      const finishDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      };

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('click', (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }, true);
    }
  }

})();

/* Anime Shop 2026: Yotpo loyalty Hebrew copy */
(() => {
  const setText = (selector, value) => {
    const node = document.querySelector(selector);
    if (node && node.textContent.trim() !== value) node.textContent = value;
  };

  const localizeYotpoLoyalty = () => {
    setText('.yotpo-drawer-logged-out-headline-text', 'מועדון האוטאקו של Anime Shop');
    setText('.yotpo-drawer-sign-up-title-text', 'הצטרפות חינם');
    setText('.yotpo-drawer-sign-up-subtitle-text', 'צוברים נקודות בכל קנייה ומקבלים הטבות בלעדיות');
    setText('.yotpo-drawer-sign-in > .yotpo-drawer-sign-in-text', 'כבר חברים במועדון?');
    setText('.yotpo-drawer-sign-in-link .yotpo-drawer-sign-in-text', 'להתחברות');
    setText('.yotpo-banner-logged-out-text', 'מועדון האוטאקו — מצטרפים ונהנים');
  };

  let yotpoFrame = 0;
  const scheduleYotpoLocalization = () => {
    if (yotpoFrame) return;
    yotpoFrame = requestAnimationFrame(() => {
      yotpoFrame = 0;
      localizeYotpoLoyalty();
    });
  };

  localizeYotpoLoyalty();
  new MutationObserver(scheduleYotpoLocalization).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* Anime Shop 2026: consent validation and hidden app-dialog accessibility */
(() => {
  document.querySelectorAll('[data-a26-club-form]').forEach((form) => {
    const phone = form.querySelector('[data-a26-sms-phone]');
    const consent = form.querySelector('[data-a26-sms-consent]');
    if (!phone || !consent) return;

    const validateSmsConsent = () => {
      const missingPhone = consent.checked && !phone.value.trim();
      phone.setCustomValidity(missingPhone ? 'כדי לקבל עדכוני SMS יש להזין מספר טלפון נייד.' : '');
    };

    consent.addEventListener('change', validateSmsConsent);
    phone.addEventListener('input', validateSmsConsent);
    form.addEventListener('submit', validateSmsConsent);
  });

  const syncHiddenDialogs = () => {
    document.querySelectorAll('.nm-modal-container').forEach((container) => {
      const styles = getComputedStyle(container);
      const hidden = styles.pointerEvents === 'none' || Number.parseFloat(styles.opacity || '1') === 0;
      if (hidden) {
        container.setAttribute('aria-hidden', 'true');
        container.inert = true;
      } else {
        container.removeAttribute('aria-hidden');
        container.inert = false;
      }
    });
  };

  let dialogFrame = 0;
  const scheduleDialogSync = () => {
    if (dialogFrame) return;
    dialogFrame = requestAnimationFrame(() => {
      dialogFrame = 0;
      syncHiddenDialogs();
    });
  };

  syncHiddenDialogs();
  new MutationObserver(scheduleDialogSync).observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['class', 'style']
  });

  // Contact details, policy link and resilient variant error handling.
  document.querySelectorAll('a[href$="/privacy-policy/"]').forEach((link) => {
    link.setAttribute('href', '/pages/privacy-policy');
  });

  if (window.location.pathname.indexOf('/pages/') === 0) {
    document.querySelectorAll('.text-columns-img__description p').forEach((paragraph) => {
      if (paragraph.textContent.trim() === '0559938088' && !paragraph.querySelector('a')) {
        paragraph.innerHTML = '<a href="tel:+972559938088" dir="ltr" aria-label="חייגו לאנימה שופ 055-993-8088">055-993-8088</a>';
      }
    });
  }

  document.querySelectorAll('product-form').forEach((productForm) => {
    if (typeof productForm.handleErrorMessage !== 'function') {
      productForm.handleErrorMessage = function(errorMessage = false) {
        const wrapper = this.querySelector('.product-form__error-message-wrapper');
        const message = this.querySelector('.product-form__error-message');
        if (!wrapper || !message) return;
        wrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) message.textContent = errorMessage;
      };
    }
  });
})();

/* Anime Shop 2026: app controls accessibility and stable dimensions */
(() => {
  let accessibilityDrawerInitialized = false;

  const enhanceAppControls = () => {
    const drawer = document.querySelector('#aa-cc-left-drawer-menu');
    if (drawer && !accessibilityDrawerInitialized) {
      drawer.classList.remove('aa-cc-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      accessibilityDrawerInitialized = true;
    }

    const launcher = document.querySelector('#aa-cc-fix-icon-body');
    if (launcher) {
      if (launcher.tagName === 'A') launcher.removeAttribute('href');
      launcher.setAttribute('role', 'button');
      launcher.setAttribute('aria-label', 'פתיחת תפריט הנגישות');
      launcher.setAttribute('title', 'פתיחת תפריט הנגישות');
      launcher.setAttribute('aria-controls', 'aa-cc-left-drawer-menu');
      const isOpen = drawer?.classList.contains('aa-cc-open');
      launcher.setAttribute('aria-expanded', String(Boolean(isOpen)));
    }

    if (drawer) {
      const isOpen = drawer.classList.contains('aa-cc-open');
      const isMobile = window.matchMedia('(max-width: 800px)').matches;
      drawer.setAttribute('aria-hidden', String(!isOpen));
      drawer.inert = !isOpen;
      drawer.style.setProperty('right', 'auto', 'important');
      drawer.style.setProperty('left', isOpen ? (isMobile ? '12px' : '16px') : '-480px', 'important');
      drawer.style.setProperty('top', isMobile ? '12px' : '16px', 'important');
      drawer.style.setProperty('bottom', 'auto', 'important');
      drawer.style.setProperty('width', isMobile ? 'min(420px, calc(100vw - 24px))' : 'min(460px, calc(100vw - 32px))', 'important');
      drawer.style.setProperty('max-width', isMobile ? '420px' : '460px', 'important');
      drawer.style.setProperty('height', isMobile ? 'calc(100dvh - 96px)' : 'min(760px, calc(100dvh - 32px))', 'important');
      drawer.style.setProperty('max-height', isMobile ? 'calc(100dvh - 96px)' : 'calc(100dvh - 32px)', 'important');
      drawer.style.setProperty('overflow', 'hidden', 'important');
      drawer.style.setProperty('flex-direction', 'column', 'important');
      drawer.style.setProperty('justify-content', 'flex-start', 'important');
      drawer.style.setProperty('align-items', 'stretch', 'important');
      drawer.style.setProperty('border-radius', '0 18px 18px 0', 'important');
      drawer.style.setProperty('transform', 'none', 'important');
      const drawerHeader = drawer.querySelector(':scope > .ada-cc-header-part');
      if (drawerHeader) {
        drawerHeader.style.setProperty('flex', '0 0 auto', 'important');
        drawerHeader.style.setProperty('width', '100%', 'important');
      }
      const drawerContent = drawer.querySelector(':scope > .ada-cc-drawer-spacing');
      if (drawerContent) {
        drawerContent.style.setProperty('flex', '1 1 auto', 'important');
        drawerContent.style.setProperty('width', '100%', 'important');
        drawerContent.style.setProperty('height', 'auto', 'important');
        drawerContent.style.setProperty('min-height', '0', 'important');
        drawerContent.style.setProperty('overflow-y', 'auto', 'important');
      }
      const title = drawer.querySelector('h2');
      if (title && title.textContent.trim() === 'Accessibility Assistant') {
        title.textContent = 'תפריט נגישות';
      }
    }

    const providerCredit = document.querySelector('#cartcoders_accessibility_inside_widget_icon');
    if (providerCredit) {
      providerCredit.hidden = true;
      providerCredit.setAttribute('aria-hidden', 'true');
      providerCredit.inert = true;
      providerCredit.style.setProperty('display', 'none', 'important');
    }

    document.querySelectorAll('#cartcoders_accessibility_inside_widget_icon_wrapper, #report_a_problem').forEach((creditLink) => {
      creditLink.removeAttribute('href');
      creditLink.setAttribute('aria-hidden', 'true');
      creditLink.inert = true;
      creditLink.style.setProperty('display', 'none', 'important');
    });

    document.querySelectorAll('.nm-modal-container img').forEach((image) => {
      if (!image.getAttribute('width')) image.setAttribute('width', '100');
      if (!image.getAttribute('height')) image.setAttribute('height', '100');
      if (!image.getAttribute('alt')) image.setAttribute('alt', 'תמונת מוצר ברשימת המשאלות');
    });
  };

  let appControlFrame = 0;
  const scheduleAppControlEnhancement = () => {
    if (appControlFrame) return;
    appControlFrame = requestAnimationFrame(() => {
      appControlFrame = 0;
      enhanceAppControls();
    });
  };

  enhanceAppControls();
  new MutationObserver(scheduleAppControlEnhancement).observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['class', 'aria-hidden', 'style']
  });
})();
